import {runOnPage} from './general.js';

runOnPage('homepage-default', () => {

	// SPLASH
	function wrapLetters(selector) {
		let index = 0;

		$(selector).each(function () {
			const $el = $(this);
			const nodes = [];

			$el.contents().each(function () {
				if (this.nodeType === Node.TEXT_NODE) {
					const text = this.nodeValue.replace(/[\r\n\t]+/g, '').trimStart();

					for (const ch of text) {
						const delay = (index++ * 0.03).toFixed(2);
						const safeChar = ch === ' ' ? '&nbsp;' : ch;
						nodes.push(
							`<span class="char" style="animation-delay:${delay}s">${safeChar}</span>`
						);
					}

				} else if (
					this.nodeType === Node.ELEMENT_NODE &&
					this.classList.contains('color-reveal')
				) {
					const delaySpace = (index++ * 0.03).toFixed(2);
					nodes.push(
						`<span class="char" style="animation-delay:${delaySpace}s">&nbsp;</span>`
					);

					const delay = (index++ * 0.03).toFixed(2);
					nodes.push(
						`<span class="char" style="animation-delay:${delay}s">${this.outerHTML}</span>`
					);

				} else if (this.nodeType === Node.ELEMENT_NODE) {
					nodes.push(this.outerHTML);
				}
			});

			$el.html(nodes.join(''));
		});
	}

	$(window).on('load', function () {
		const $htmlBody = $('html, body');
		const $splash = $('#splash');
		const $heading = $('#splash-heading');
		const $section = $('#splash-section');
		const $letsWork = $('#letsWork');

		if (window.location.hash) {
			$splash.remove();
			$heading.addClass('visible');
			$section.addClass('visible');
			$letsWork.addClass('visible');
			$htmlBody.removeClass('lock-scroll');

			requestAnimationFrame(() => {
				const $el = $(window.location.hash);
				if ($el.length) {
					$el[0].scrollIntoView({ behavior: 'smooth' });
				}
			});
			return;
		}

		$heading.css({
			position: 'relative',
			zIndex: 9999
		});

		$htmlBody.addClass('lock-scroll');

		if (window.innerWidth > 1024) {
			wrapLetters('#splash-heading p');

			setTimeout(() => {
				$heading.addClass('visible');
			}, 500);

			setTimeout(() => {
				$splash.addClass('slide-out');

				setTimeout(() => {
					requestAnimationFrame(() => {
						$('.color-reveal').addClass('animate');
					});
				}, 490);
			}, 1500);

			$splash.on('animationend webkitAnimationEnd oAnimationEnd', function (e) {
				if (e.originalEvent.animationName !== 'slide-out') {
					return;
				}

				$heading.css({
					position: '',
					zIndex: ''
				});

				$splash.remove();
				$htmlBody.removeClass('lock-scroll');
				$section.addClass('visible');
				setTimeout(() => {
					$letsWork.addClass('visible');
				}, 300);
			});

		}
		else {
			$splash.remove();
			$heading.addClass('visible');
			$section.addClass('visible');
			$letsWork.addClass('visible');
			$htmlBody.removeClass('lock-scroll');
		}
	});


	// PLAY WORLD VIDEO
	document.addEventListener("DOMContentLoaded", function () {
		const video = document.getElementById("worldVideo");
		if (video) {
			video.load();
		}
	});


	// PLAY DRON VIDEO
	$(function(){
		const $videos = $('video.lazy-autoplay');

		$videos.each(function(){
			this.playedOnce = false;
			this.addEventListener('ended', () => {
				this.playedOnce = true;
			});
		});

		function checkVideos() {
			const windowHeight = $(window).height();

			$videos.each(function(){
				const rect = this.getBoundingClientRect();
				const inView = rect.top < windowHeight && rect.bottom > 0;

				if (inView && !this.playedOnce) {
					this.play();
				} else if (!inView) {
					if (!this.playedOnce) this.pause();
				}
			});
		}

		$(window).on('scroll resize', checkVideos);
		checkVideos();
	});


// TEXT ANIMATION
	$(function(){
		const $win       = $(window);
		const $container = $('.animate-text');
		const $lines     = $container.find('.line');

		function onScroll(){
			const scrollTop = $win.scrollTop();
			const winH      = $win.height();

			const top       = $container.offset().top;
			const height    = $container.outerHeight();

			const centerY   = scrollTop + winH / 2;

			let p = (centerY - top) / height;
			if (p < 0) p = 0;
			if (p > 1) p = 1;

			const idx = Math.min(2, Math.floor(p * 3));

			$lines.removeClass('active')
				.eq(idx).addClass('active');
		}

		$win.on('scroll resize', onScroll);
		onScroll();
	});
});
